













































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import SitesSelector from "@/components/SitesSelector.vue";
import DatePicker from "@/components/DatePicker.vue";
import Campaign, { LineItem } from "@/models/campaign";
import moment from "moment";
// import Definition from "@/models/definition";
import AdUnit, { AdUnitFilter } from "@/models/adUnit";
import AdUnitsSelector from "@/components/AdUnitsSelector.vue";
import DefinitionsAPI from "@/services/definitions";
import DefinitionsSelector from "@/components/DefinitionsSelector.vue";
import { LayoutModule } from "@/store/layout";
import { LineItemModule } from "@/store/lineItem";
import { CampaignModule } from "@/store/campaign";
import CampaignsAPI from "@/services/campaigns";
import { EventBus } from "@/main";
import Definition, {
  DefinitionBatch,
  DefinitionList,
} from "@/models/definition";
import { cloneDeep, get } from "lodash";
import { QueryParams } from "@/models/general";

@Component({
  components: {
    SitesSelector,
    DatePicker,
    AdUnitsSelector,
    DefinitionsSelector,
  },
})
export default class LineItemForm extends Vue {
  @Prop({ default: null }) initialLineItem!: LineItem | null;
  @Prop({ default: () => [] }) initialLineItems!: LineItem[];
  @Prop({ default: false }) multiple!: boolean;
  @Prop({ default: false }) edit!: boolean;

  model: LineItem = new LineItem();
  lineItems: LineItem[] = [];
  dates: string[] = [moment().format(), moment().format()];
  adUnits: AdUnit[] = [];
  selectedAdUnit: AdUnit | null = null;
  definitions: DefinitionList[] = [];

  created(): void {
    if (this.initialLineItem !== null) {
      this.model = new LineItem(this.initialLineItem);
      this.model.localId = this.initialLineItem.localId;
      this.dates = [
        moment(this.model.start).format(),
        moment(this.model.end).format(),
      ];
    }

    this.getData();
  }

  validate(): void {
    const validForm = (this.$refs.form as Vue & {
      validate: () => boolean;
    }).validate();

    if (validForm) {
      !this.multiple ? this.save() : this.saveBatch();
    }
  }

  get adUnitFilters(): AdUnitFilter {
    const filter = {
      filter: {
        site_ids: this.model.siteId,
      },
      fields: {
        ad_unit: ["id", "ref", "name", "definition_value_ids"].join(","),
      },
      page: {
        size: -1,
      },
    };
    return filter;
  }

  get batchEdit(): boolean {
    return this.initialLineItems.length > 0 && this.edit;
  }

  async getData(): Promise<void> {
    try {
      const r = await DefinitionsAPI.list(-1);
      this.definitions = r.data;
    } catch (e) {
      console.log(e);
    }
  }

  onSelectAdUnit(adUnit: AdUnit): void {
    this.selectedAdUnit = adUnit;
  }

  @Watch("adUnits", { deep: true })
  watchAdUnitChange(id: string): void {
    const adunit = this.adUnits.find((a: AdUnit) => {
      return a.id === id;
    });
  }

  @Watch("dates")
  setDateRange(): void {
    this.model.start = moment(this.dates[0]).toDate();
    this.model.end = moment(this.dates[1]).toDate();
  }

  async save(): Promise<void> {
    if (this.model.id !== "") {
      await this.update();
      LineItemModule.updateLineItem(this.model);
      // EventBus.$emit("updateCampaignLineItem", this.model);
    } else {
      if (CampaignModule.getCurrentCampaign.id) {
        const r = await this.new();

        if (r) {
          LineItemModule.addLineItem(r);
          LineItemModule.updateLineItem(r);
        }
        // EventBus.$emit("fetchCampaignsLineItems", this.model);
      } else {
        //
        LineItemModule.addLineItem(this.model);
        LineItemModule.updateLineItem(this.model);
      }
    }
    LayoutModule.hideRightDrawer();
  }

  async saveBatch(): Promise<void> {
    !this.batchEdit
      ? this.saveBatchNewLineItems()
      : this.saveBatchExistingLineItems();
  }

  async saveBatchExistingLineItems(): Promise<void> {
    const lineItems: LineItem[] = cloneDeep(this.initialLineItems);
    lineItems.forEach((i) => {
      i.start = this.model.start;
      i.end = this.model.end;
    });

    try {
      LayoutModule.showLoader();

      const r = await CampaignsAPI.lineItems.batch.update(
        lineItems,
        CampaignModule.getCurrentCampaign.id as string
      );

      // Update Local LineItems
      lineItems.forEach((i) => {
        LineItemModule.updateLineItem(i);
      });

      LayoutModule.setAlerts({
        text: this.$t(
          "campaigns.responses.success_line_items_updated"
        ).toString(),
        type: "success",
      });
      LayoutModule.hideRightDrawer();
    } catch (e) {
      console.log(e);
      LayoutModule.setAlerts({
        text: this.$t(
          "campaigns.responses.error_line_items_updated"
        ).toString(),
        type: "error",
      });
    } finally {
      LayoutModule.hideLoader();
    }
  }

  async saveBatchNewLineItems(): Promise<void> {
    console.log("new line items");
    const lineItems: LineItem = new LineItem(this.model);

    // Compose DefinitionBatch
    this.definitions.forEach((d: DefinitionList) => {
      const definitionElements = new DefinitionBatch();
      definitionElements.id = d.id;
      definitionElements.name = d.name;
      definitionElements.value = d.value;

      this.model.definitionValueIds.forEach((value: string) => {
        const elem = d.values.find((e) => e.id === value);

        elem && elem.id ? definitionElements.values.push(elem.id) : null;
      });

      definitionElements.values.length > 0
        ? lineItems.definitions?.push(definitionElements)
        : null;
    });

    try {
      const payload = {
        id: CampaignModule.getCurrentCampaign.id
          ? CampaignModule.getCurrentCampaign.id
          : null,
        lineItems: lineItems,
      };

      const r = await CampaignsAPI.lineItems.generate_line_items(payload);

      if (CampaignModule.getCurrentCampaign.id) {
        LineItemModule.setLineItems((r as Campaign).lineItems);
      } else {
        (r as LineItem[]).forEach((e) => {
          const l = new LineItem(e);
          LineItemModule.addLineItem(l);
        });
      }
    } catch (e) {
      console.log(e);
    }
    LayoutModule.hideRightDrawer();
  }

  cancel(): void {
    LayoutModule.hideRightDrawer();
  }

  async update(): Promise<void> {
    try {
      if (this.model.id && CampaignModule.getCurrentCampaign.id) {
        await CampaignsAPI.lineItems.update(
          this.model,
          CampaignModule.getCurrentCampaign.id
        );

        LayoutModule.setAlerts({
          text: this.$t(
            "campaigns.responses.success_line_item_update"
          ).toString(),
          type: "success",
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  async new(): Promise<LineItem | undefined> {
    let r = undefined;
    try {
      if (CampaignModule.getCurrentCampaign.id) {
        r = await CampaignsAPI.lineItems.new(
          this.model,
          CampaignModule.getCurrentCampaign.id
        );
      }

      LayoutModule.setAlerts({
        text: this.$t(
          "campaigns.responses.success_line_item_create"
        ).toString(),
        type: "success",
      });
    } catch (e) {
      console.log(e);
    }

    return r;
  }
}
